module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 y-middle"
  }, [_c('div', {
    staticClass: "inline-block pull-left text-left"
  }, [(_vm.storeName) ? _c('h4', [_vm._v("\n          " + _vm._s(_vm.storeName) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'reDisProduct') ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 未勾選解除停賣的項目，會保持原門市設定。")]) : (_vm.$route.name === 'disProduct') ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 未勾選停賣的項目，會保持原門市設定。")]) : _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 未勾選者，將會取消停賣功能。")]), _vm._v(" "), (_vm.$route.name == 'reDisProduct') ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各分類中若有相同料號的商品，會同步解除停賣。")]) : (_vm.$route.name === 'disProduct') ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各分類中若有相同料號的商品，會同步停賣。")]) : _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 各分類中若有相同料號的商品，會同步停賣、解除停賣。")]), _vm._v(" "), (_vm.isDaily) ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 系統將於您的商店打烊後，自動解除停賣當日停賣商品。")]) : _vm._e(), _vm._v(" "), (_vm.isDaily) ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 當日打烊後及公休日無法進行設定，跨日後若無遇公休可設定。")]) : _vm._e(), _vm._v(" "), (_vm.isDaily) ? _c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 如您有其他的設定需求，可使用「時段停賣管理」、「永久停賣」進行設定。")]) : _vm._e()])]), _vm._v(" "), (_vm.isDayOff) ? _c('div', {
    staticClass: "col-xs-12 dialy-hint"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" " + _vm._s(_vm.isDayOff) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.category.length > 0) ? _c('div', {
    staticClass: "col-xs-12 y-middle"
  }, [_c('div', {
    staticClass: "hr-line"
  }), _vm._v(" "), (_vm.$route.name === 'reDisProduct') ? _c('div', {
    staticClass: "h3-title"
  }, [_vm._v("商品解除" + _vm._s(_vm.timeType) + "停賣設定")]) : _c('div', {
    staticClass: "h3-title"
  }, [_vm._v("商品" + _vm._s(_vm.timeType) + "停賣設定")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "grid",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.category), function(c, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-item p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 m-b-5 text-left p-x-15"
    }, [_c('div', {
      staticClass: "text-right inline-block block-checkbox text-15",
      staticStyle: {
        "margin-right": "10px"
      }
    }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v("解除停賣")]) : _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v("停賣")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(c.name) + " "), _c('small', [_vm._v(_vm._s(c.remark))])]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (c.is_disabled),
        expression: "c.is_disabled"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'c-' + c.product_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(c.is_disabled) ? _vm._i(c.is_disabled, null) > -1 : (c.is_disabled)
      },
      on: {
        "input": function($event) {
          return _vm.changeCategoryAdd(c)
        },
        "change": function($event) {
          var $$a = c.is_disabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(c, "is_disabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(c, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(c, "is_disabled", $$c)
          }
        }
      }
    })]) : _c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (c.is_disabled),
        expression: "c.is_disabled"
      }],
      staticClass: "css-checkbox",
      attrs: {
        "type": "checkbox",
        "id": 'c-' + c.product_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(c.is_disabled) ? _vm._i(c.is_disabled, null) > -1 : (c.is_disabled)
      },
      on: {
        "input": function($event) {
          return _vm.changeCategoryAdd(c)
        },
        "change": function($event) {
          var $$a = c.is_disabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(c, "is_disabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(c, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(c, "is_disabled", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "css-label css-label-add",
      attrs: {
        "for": 'c-' + c.product_id + '-is-add'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((c.child_list), function(p, index) {
      return _c('li', {
        staticClass: "card-product"
      }, [_c('div', {
        class: p.is_disabled && _vm.$route.name !== 'reDisProduct' ? 'delete-line' : ''
      }, [_vm._v("\n                    " + _vm._s(p.name) + " "), _c('small', [_vm._v(_vm._s(p.remark ? ("(" + (p.remark) + ")") : ''))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_disabled),
          expression: "p.is_disabled"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'p-' + p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_disabled) ? _vm._i(p.is_disabled, null) > -1 : (p.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, p)
          },
          "change": function($event) {
            var $$a = p.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_disabled", $$c)
            }
          }
        }
      })]) : _c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (p.is_disabled),
          expression: "p.is_disabled"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": 'p-' + p.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(p.is_disabled) ? _vm._i(p.is_disabled, null) > -1 : (p.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.changeProductAdd(c, p)
          },
          "change": function($event) {
            var $$a = p.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(p, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(p, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(p, "is_disabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": 'p-' + p.product_id + '-is-add'
        }
      })])])])])
    }), 0)])])])
  }), 0)]), _vm._v(" "), (_vm.optionsAll && _vm.optionsAll.length > 0 && _vm.$route.name === 'reDisProduct') ? _c('div', {
    staticClass: "col-xs-12 y-middle m-t-10 m-b-10"
  }, [_c('div', {
    staticClass: "hr-line"
  }), _c('div', {
    staticClass: "h3-title"
  }, [_vm._v("配料解除" + _vm._s(_vm.timeType) + "停賣設定")])]) : (_vm.optionsAll && _vm.optionsAll.length > 0) ? _c('div', {
    staticClass: "col-xs-12 y-middle m-t-10 m-b-10"
  }, [_c('div', {
    staticClass: "hr-line"
  }), _c('div', {
    staticClass: "h3-title"
  }, [_vm._v("配料" + _vm._s(_vm.timeType) + "停賣設定")])]) : _vm._e(), _vm._v(" "), (_vm.optionsAll && _vm.optionsAll.length > 0) ? _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "gridI",
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.optionsAll), function(ot, otIndex) {
    return _c('div', {
      staticClass: "col-xs-12 col-lg-4 grid-itemI p-5"
    }, [_c('div', {
      staticClass: "col-xs-12 card"
    }, [_c('div', {
      staticClass: "col-xs-12 m-b-5 text-left p-x-15"
    }, [_c('div', {
      staticClass: "text-right inline-block block-checkbox text-15",
      staticStyle: {
        "margin-right": "10px"
      }
    }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v("解除停賣")]) : _c('span', {
      staticClass: "text-dark-gray text-13"
    }, [_vm._v("停賣")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 card-title text-left p-x-15"
    }, [_c('span', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(ot.name) + " "), _c('small', [_vm._v(_vm._s(ot.remark))])]), _vm._v(" "), _c('div', {
      staticClass: "text-right inline-block m-r-15 block-checkbox"
    }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ot.is_disabled),
        expression: "ot.is_disabled"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'o-' + ot.product_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(ot.is_disabled) ? _vm._i(ot.is_disabled, null) > -1 : (ot.is_disabled)
      },
      on: {
        "input": function($event) {
          return _vm.changeAdjustAddAll(ot)
        },
        "change": function($event) {
          var $$a = ot.is_disabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ot, "is_disabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ot, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ot, "is_disabled", $$c)
          }
        }
      }
    })]) : _c('span', {
      staticClass: "checkbox-addmenu"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ot.is_disabled),
        expression: "ot.is_disabled"
      }],
      staticClass: "css-checkbox",
      attrs: {
        "type": "checkbox",
        "id": 'o-' + ot.product_id + '-is-add'
      },
      domProps: {
        "checked": Array.isArray(ot.is_disabled) ? _vm._i(ot.is_disabled, null) > -1 : (ot.is_disabled)
      },
      on: {
        "input": function($event) {
          return _vm.changeAdjustAddAll(ot)
        },
        "change": function($event) {
          var $$a = ot.is_disabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(ot, "is_disabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(ot, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(ot, "is_disabled", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "css-label css-label-add",
      attrs: {
        "for": 'o-' + ot.product_id + '-is-add'
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 text-left"
    }, [_c('ul', {
      staticClass: "nav p-x-15"
    }, _vm._l((ot.child_list), function(a, index) {
      return _c('li', {
        staticClass: "card-product"
      }, [_c('div', {
        class: a.is_disabled && _vm.$route.name !== 'reDisProduct' ? 'delete-line' : ''
      }, [_vm._v("\n                    " + _vm._s(a.name) + " "), _c('small', [_vm._v(_vm._s(a.remark ? ("(" + (a.remark) + ")") : ''))]), _vm._v(" "), _c('div', {
        staticClass: "text-right inline-block block-checkbox"
      }, [(_vm.$route.name === 'reDisProduct') ? _c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (a.is_disabled),
          expression: "a.is_disabled"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'a-' + a.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(a.is_disabled) ? _vm._i(a.is_disabled, null) > -1 : (a.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.checkAdjustAll(a, ot)
          },
          "change": function($event) {
            var $$a = a.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(a, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(a, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(a, "is_disabled", $$c)
            }
          }
        }
      })]) : _c('span', {
        staticClass: "checkbox-addmenu"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (a.is_disabled),
          expression: "a.is_disabled"
        }],
        staticClass: "css-checkbox",
        attrs: {
          "type": "checkbox",
          "id": 'a-' + a.product_id + '-is-add'
        },
        domProps: {
          "checked": Array.isArray(a.is_disabled) ? _vm._i(a.is_disabled, null) > -1 : (a.is_disabled)
        },
        on: {
          "input": function($event) {
            return _vm.checkAdjustAll(a, ot)
          },
          "change": function($event) {
            var $$a = a.is_disabled,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(a, "is_disabled", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(a, "is_disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(a, "is_disabled", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "css-label css-label-add",
        attrs: {
          "for": 'a-' + a.product_id + '-is-add'
        }
      })])])])])
    }), 0)])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.$route.params.store_id && _vm.$route.name === 'disProduct') ? _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('h5', [_vm._v("參與停賣店家\n          ")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting
    }
  })], 1)])]) : (!_vm.$route.params.store_id && _vm.$route.name === 'reDisProduct') ? _c('div', {
    staticClass: "col-xs-12 p-10"
  }, [_c('div', {
    staticClass: "col-xs-12 p-sm-10-p m-x-10 form-left"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('h5', [_vm._v("參與解除停賣店家\n          ")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.isDayOff) ? _c('div', {
    staticClass: "col-xs-12 dialy-hint"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center",
    class: {
      'box-border': !_vm.isDayOff
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/disItemTable"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gotoNext
    }
  }, [_vm._v("\n      確定\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e2088e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RealTime/Temp/DisProdTemp.vue
// module id = 2372
// module chunks = 1